<template>
  <Transition name="fade">
    <nav v-if="chair && pages" class="fixed top-0 left-0 w-full z-20 border-line border-b">
      <DesktopNavigation :chair="chair" :pages="pages" :sections="sections" />
      <MobileNavigation :chair="chair" :pages="pages" :sections="sections" />
    </nav>
  </Transition>
</template>

<script lang="ts">
import { DesktopNavigation, MobileNavigation } from "@/components/navigation/blocks";
import type { PropType } from "vue";

export default {
  name: "SiteNavigation",
  components: { DesktopNavigation, MobileNavigation },
  computed: {
    sections() {
      return [
        {
          icon: "compass",
          pages: ["about", "innovation", "team"],
          title: this.$t("navigation.about"),
        },
        {
          icon: "flag",
          pages: ["news", "events"],
          title: this.$t("navigation.activities"),
        },
        {
          icon: "book",
          pages: ["projects", "posts", "documents", "funding"],
          title: this.$t("navigation.research"),
        },
        {
          icon: "user",
          pages: ["careers"],
          title: this.$t("navigation.careers"),
        },
      ] as MenuSection[];
    },
  },
  props: {
    chair: {
      type: [Object, null] as PropType<Chair | null>,
      required: true,
    },
    pages: {
      type: Object as PropType<Record<template, Page>>,
      required: true,
    },
  },
};
</script>
